import React from "react";

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  isProtected?: boolean;
};

const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ isProtected = false, onContextMenu, ...props }, ref) => {
    const handleContextMenu = React.useCallback(
      (e: React.MouseEvent<HTMLImageElement>) => {
        if (isProtected) {
          e.preventDefault();
        }
        onContextMenu?.(e);
      },
      [isProtected, onContextMenu]
    );

    return (
      <img
        {...props}
        ref={ref}
        draggable={isProtected ? false : props.draggable}
        onContextMenu={handleContextMenu}
      />
    );
  }
);

export default Image;
